import React, { FC, memo } from 'react'
import styled from 'styled-components'

import Text from '../../../ui/Text'

const SLink = styled.a`
    & {
        color: ${({ theme }) => theme.font.darkestColor};
        font-size: 21px;
        line-height: 28px;
        display: block;
        display: block;
    }

    &:hover {
        color: ${({ theme }) => theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme }) => theme.font.midDarkColor};
    }
`

type TitleLinkFieldProps = {
    titleCode: string
    text: string
    href?: string
    dataTestId?: string
}

const TitleLinkField: FC<TitleLinkFieldProps> = ({ titleCode, text, dataTestId, href }) => {
    return (
        <div className="margin-top-small">
            <Text code={titleCode} />
            <SLink href={href} target="_blank" data-testid={dataTestId}>
                {text}
            </SLink>
        </div>
    )
}

export default memo(TitleLinkField)
